// frontend/src/hooks/useGroupInfo.js

export function useGroupInfo(groupInfo, session) {
  return {
    ...groupInfo,
    group_name:
      groupInfo?.group_name ||
      session?.group_name ||
      session?.groupName ||
      null,
    owner_name:
      groupInfo?.owner_name ||
      session?.owner_name ||
      session?.ownerName ||
      null,
  };
}